import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import { useEdgeSpreading } from "./useEdgeSpreading";
const EdgeSpreadingContext = /*#__PURE__*/ createContext(null);
export function EdgeSpreadingProvider({ edges, nodes, options, children }) {
    const spreading = useEdgeSpreading(edges, nodes, options);
    return /*#__PURE__*/ _jsx(EdgeSpreadingContext.Provider, {
        value: spreading,
        children: children
    });
}
/**
 * Returns the spreading map (edgeId → centerX) or null if no provider is present.
 */ export function useEdgeSpreadingContext() {
    return useContext(EdgeSpreadingContext);
}

//# sourceMappingURL=EdgeSpreadingContext.js.map